import { Component, signal, type SimpleChanges } from '@angular/core';

import type { TellentMemberBrief } from '@core/ask-hr-types';
import { componentOutletConfigFactory } from '@core/common-legacy';
import { injectTranslate } from '@core/i18n-legacy';
import { AvatarComponent } from '@core/user-interface-legacy';

import { AsksColumnId, defineAskTableColumn } from './types';

/* eslint-disable @angular-eslint/no-inputs-metadata-property */
/* eslint-disable @typescript-eslint/consistent-type-assertions */

@Component({
  selector: 'employee-column',
  imports: [AvatarComponent],
  template: `
    <rt-avatar
      [type]="employee.avatarThumbUrl ? 'image' : 'initials'"
      size="small"
      [initials]="initials()"
      [imageSrc]="employee.avatarThumbUrl"
      margin-right-small
    />
    {{ employee?.firstName }} {{ employee?.lastName }}
  `,
  inputs: EmployeeColumnComponent.NgInputs,
  styles: [
    `
      :host {
        display: flex;
        align-items: center;
      }
    `,
  ],
})
export class EmployeeColumnComponent {
  public static NgInputs = ['employee' as const];

  public employee: TellentMemberBrief;
  protected initials = signal('');

  public ngOnChanges(changes: SimpleChanges) {
    if (changes.employee && this.employee) {
      const { firstName, lastName } = this.employee;
      this.initials.set(`${firstName?.[0] || ''}${lastName?.[0] || ''}`);
    }
  }
}

export const employeeColumn = defineAskTableColumn(() => ({
  id: AsksColumnId.Employee,
  label: injectTranslate()('tlc.ask_hr.requests.employee'),
  visible: true,
  geometry: {
    width: 250,
    minWidth: 200,
    autoFitProp: 'width',
  },
  options: {
    draggable: true,
    resizable: true,
    removable: false,
    sortable: true,
  },
  componentFactory: ({ row }) =>
    componentOutletConfigFactory(EmployeeColumnComponent, {
      inputs: { employee: row.requester },
    }),
}));
